import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

type Props = {
  aperta: boolean;
  onChiudi: () => void;
  onCrea: (nome: string) => Promise<void>;
};

/** Crea un evento con il solo nome: programma e impostazioni si completano nella sua pagina. */
export function NuovoEventoDialog({ aperta, onChiudi, onCrea }: Props) {
  const [nome, setNome] = useState('');
  const [creando, setCreando] = useState(false);

  useEffect(() => {
    if (aperta) setNome('');
  }, [aperta]);

  const crea = async () => {
    if (!nome.trim()) return;
    setCreando(true);
    try {
      await onCrea(nome);
    } finally {
      setCreando(false);
    }
  };

  return (
    <Dialog open={aperta} onOpenChange={(v) => !v && onChiudi()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Nuovo evento</DialogTitle>
          <DialogDescription>
            Un congresso o un convegno con un programma a scelta. Dopo averlo creato scegli la lista dei partecipanti e
            importi il programma.
          </DialogDescription>
        </DialogHeader>
        <form
          className="py-2"
          onSubmit={(e) => {
            e.preventDefault();
            void crea();
          }}
        >
          <Label htmlFor="nome-evento" className="text-xs">
            Nome <span className="text-primary-600">*</span>
          </Label>
          <Input id="nome-evento" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Es. Congresso HS&UT 2026" className="mt-1" autoFocus />
        </form>
        <DialogFooter>
          <Button variant="outline" onClick={onChiudi} disabled={creando}>
            Annulla
          </Button>
          <Button onClick={() => void crea()} disabled={!nome.trim() || creando} className="bg-primary-600 hover:bg-primary-700 text-white">
            {creando && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Crea l'evento
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
